import { render, staticRenderFns } from "./ApplicantOnboardingStakeholders.vue?vue&type=template&id=272c9d6e&"
import script from "./ApplicantOnboardingStakeholders.vue?vue&type=script&lang=js&"
export * from "./ApplicantOnboardingStakeholders.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantOnboardingStakeholders.vue?vue&type=style&index=0&id=272c9d6e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports